import { render } from "./version.vue?vue&type=template&id=158d510c&scoped=true"
import script from "./version.vue?vue&type=script&lang=js"
export * from "./version.vue?vue&type=script&lang=js"

import "./version.vue?vue&type=style&index=0&id=158d510c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158d510c"]])

export default __exports__